export default "__VITE_ASSET__d06c2643__"